import { Checkbox, Col, Form, InputNumber, Row, Select } from "antd";
import ProgrammationSelect from "../components/ProgrammationSelect";

interface Props {
  form: any;
  isAscenseurAvailable: boolean;
  typeDeProjet: string[];
  isSousSolExistant: boolean;
  isParkingAppartementsAvailable: boolean;
  isParkingVillasAvailable: boolean;
  isEnChantier: boolean;
}

export const CaracteristiquesProjetStep: React.FC<Props> = ({
  form,
  isAscenseurAvailable,
  typeDeProjet,
  isSousSolExistant,
  isParkingAppartementsAvailable,
  isParkingVillasAvailable,
  isEnChantier,
}) => {
  return (
    <Row gutter={16} style={{ width: "100%" }} justify={"center"}>
      <Col md={10} lg={10} xs={24} sm={24}>
        {/* Phase du projet */}
        <Form.Item
          name="phase_du_projet"
          label="Phase du projet"
          rules={[
            {
              required: true,
              message: "Veuillez saisir la phase du projet",
            },
          ]}
        >
          <Select>
            <Select.Option value="en chantier">En chantier</Select.Option>
            <Select.Option value="en livraison">En livraison</Select.Option>
            <Select.Option value="livré">livré</Select.Option>
          </Select>
        </Form.Item>
        {isEnChantier && (
          <Form.Item
            name="etat_avancement"
            label="Etat d'avancement des travaux de construction"
            rules={[{ required: true }]}
          >
            <Select>
              <Select.Option value="Phase étude">Phase étude</Select.Option>
              <Select.Option value="Terrasement">Terrasement</Select.Option>
              <Select.Option value="Viabilisation">Viabilisation</Select.Option>
              <Select.Option value="Gros Oeuvres">Gros Oeuvres</Select.Option>
              <Select.Option value="Finition">Finition</Select.Option>
            </Select>
          </Form.Item>
        )}

        {/* Nombre d'unités total */}
        {typeDeProjet.includes("appartements") && (
          <Form.Item
            name="nbr_unites_appartements"
            label="Nombre d'unités des appartements"
            rules={[
              {
                required: true,
                message: "Veuillez saisir le nombre d'unités des appartements",
              },
            ]}
          >
            <InputNumber style={{ width: "100%" }} min={1} />
          </Form.Item>
        )}
        {typeDeProjet.includes("villas") && (
          <Form.Item
            name="nbr_unites_villas"
            label="Nombre d'unités des villas"
            rules={[
              {
                required: true,
                message: "Veuillez saisir le nombre d'unités des villas",
              },
            ]}
          >
            <InputNumber style={{ width: "100%" }} min={1} />
          </Form.Item>
        )}
        {typeDeProjet.includes("bureaux") && (
          <Form.Item
            name="nbr_unites_bureaux"
            label="Nombre d'unités des bureaux"
            rules={[
              {
                required: true,
                message: "Veuillez saisir le nombre d'unités des bureaux",
              },
            ]}
          >
            <InputNumber style={{ width: "100%" }} min={1} />
          </Form.Item>
        )}
        {typeDeProjet.includes("locaux commerciaux") && (
          <Form.Item
            name="nbr_unites_lc"
            label="Nombre d'unités des locaux commerciaux"
            rules={[
              {
                required: true,
                message:
                  "Veuillez saisir le nombre d'unités des locaux commerciaux",
              },
            ]}
          >
            <InputNumber style={{ width: "100%" }} min={1} />
          </Form.Item>
        )}

        {/* Nombre d'étages */}
        <Form.Item
          name="nbr_etages"
          label="Nombre d'étages"
          rules={[{ required: true }]}
        >
          <InputNumber min={0} style={{ width: "100%" }} />
        </Form.Item>

        <Form.Item
          name="cloturee"
          label="Clôture de projet"
          rules={[
            {
              required: true,
              message: "Veuillez saisir le type de standing",
            },
          ]}
        >
          <Select>
            <Select.Option value={true}>Oui</Select.Option>
            <Select.Option value={false}>Non</Select.Option>
          </Select>
        </Form.Item>
      </Col>
      <Col md={10} lg={10} xs={24} sm={24}>
        {/* acenseur et nombre d'acenseurs */}
        <Form.Item
          name="ascenseur"
          label="Présence d'ascenseur"
          rules={[
            {
              required: true,
              message: "Veuillez choisir la présence d'ascenseur",
            },
          ]}
        >
          <Select>
            <Select.Option value={true}>Oui</Select.Option>
            <Select.Option value={false}>Non</Select.Option>
          </Select>
        </Form.Item>
        {isAscenseurAvailable && (
          <Form.Item
            name="nbr_d_ascenseurs"
            label="Nombre d'ascenseurs"
            rules={[
              {
                required: true,
                message: "Veuillez saisir le nombre des ascenseurs",
              },
            ]}
          >
            <InputNumber min={1} style={{ width: "100%" }} />
          </Form.Item>
        )}

        {/* Sous-sol et nombre de sous-sol */}
        <Form.Item
          name="sous_sol"
          label="Présence de sous-sol"
          rules={[
            {
              required: true,
              message: "Veuillez choisir la présence du sous-sol",
            },
          ]}
        >
          <Select>
            <Select.Option value={false}>Non</Select.Option>
            <Select.Option value={true}>Oui</Select.Option>
          </Select>
        </Form.Item>
        {isSousSolExistant && (
          <Form.Item
            name="nbr_de_sous_sol"
            label="Nombre de sous-sols"
            rules={[
              {
                required: true,
                message: "Veuillez saisir le nombre de sous-sols",
              },
            ]}
          >
            <InputNumber min={1} style={{ width: "100%" }} />
          </Form.Item>
        )}
        {/* Parking appartements et nombre de place de parking */}
        {typeDeProjet.includes("appartements") && (
          <>
            <Form.Item
              name="parking_appartements"
              label="Parking des appartements"
              rules={[
                {
                  required: true,
                  message: "Veuillez choisir la présence du parking",
                },
              ]}
            >
              <Select>
                <Select.Option value={true}>Oui</Select.Option>
                <Select.Option value={false}>Non</Select.Option>
              </Select>
            </Form.Item>

            {isParkingAppartementsAvailable && (
              <Form.Item
                name="nbr_de_place_de_parking_appartements"
                label="Nombre de place de parking des appartements"
                rules={[
                  {
                    required: true,
                    message: "Veuillez saisir le nombre de parking",
                  },
                ]}
              >
                <InputNumber min={1} style={{ width: "100%" }} />
              </Form.Item>
            )}
          </>
        )}

        {/* Parking villas et nombre de place de parking */}
        {typeDeProjet.includes("villas") && (
          <>
            <Form.Item
              name="parking_villas"
              label="Parking des villas"
              rules={[
                {
                  required: true,
                  message: "Veuillez choisir la présence du parking",
                },
              ]}
            >
              <Select>
                <Select.Option value={true}>Oui</Select.Option>
                <Select.Option value={false}>Non</Select.Option>
              </Select>
            </Form.Item>

            {isParkingVillasAvailable && (
              <Form.Item
                name="nbr_de_place_de_parking_villas"
                label="Nombre de place de parking des villas"
                rules={[
                  {
                    required: true,
                    message: "Veuillez saisir le nombre de parking",
                  },
                ]}
              >
                <InputNumber min={1} style={{ width: "100%" }} />
              </Form.Item>
            )}
          </>
        )}
        {/* Espace vert et piscine et salle de sport */}
        <Row style={{ width: "100%" }} justify={"space-between"}>
          <Col lg={8} md={8} xs={8} sm={24}>
            <Form.Item
              name="espace_vert"
              label="Espace vert"
              valuePropName="checked"
              layout="vertical"
            >
              <Checkbox />
            </Form.Item>
            <Form.Item
              layout="vertical"
              name="piscine"
              label="Piscine"
              valuePropName="checked"
            >
              <Checkbox />
            </Form.Item>
            
          </Col>
          <Col lg={8} md={8} xs={8} sm={24}>
            <Form.Item
              name="salle_de_sport"
              label="Salle de sport"
              valuePropName="checked"
              layout="vertical"
            >
              <Checkbox />
            </Form.Item>
            <Form.Item
              name="terrain_de_sport"
              label="Terrain de sport"
              valuePropName="checked"
              layout="vertical"
            >
              <Checkbox />
            </Form.Item>
            
          </Col>
          <Col lg={8} md={8} xs={8} sm={24}>
            
            <Form.Item
              name="creche"
              label="Crèche"
              valuePropName="checked"
              layout="vertical"
            >
              <Checkbox />
            </Form.Item>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};
